<template>
  <div class="tw-relative">
    <div ref="trigger">
      <slot :count="totalUnread" :open="open"></slot>
    </div>
    <div ref="menu" v-show="is_open" class="tw-rounded tw-overflow-hidden tw-bg-light tw-shadow tw-w-120">
      <div class="tw-divide-y tw-divide-light-3">
        <div class="tw-text-2xl tw-font-bold tw-p-4">Latest Notifications:</div>
        <div v-if="loading" class="tw-p-10 tw-flex flex-center">
          <i class="bx bx-loader-alt bx-spin tw-text-4xl"></i>
        </div>
        <template v-else>
          <div v-if="latestNotifications.length === 0" class="tw-py-16 tw-text-center tw-font-bold tw-text-light-11">No New Notifications</div>
          <a
            target="_blank" v-on:click="delayedRefresh"
            :href="`/dashboard/notifications/${notification.id}`" class="tw-p-4 tw-flex tw-items-center tw-space-x-4 cursor:tw-bg-light-2 cursor:tw-text-blue"
            v-for="notification in latestNotifications" :key="notification.id"
          >
            <i class="bx bx-bell tw-text-3xl"></i>
            <div>
              <div class="tw-font-semibold">{{notification.data.title}}</div>
              <div class="tw-text-dark-3 tw-text-opacity-75">{{notification.data.message}}</div>
            </div>
            <!--<span class="tw-flex-grow"></span>
            <button class="tw-p-2 cursor:tw-text-red" v-on:click.prevent="read(notification)">
              <i class="bx bx-trash tw-text-3xl" ></i>
            </button>-->
          </a>
          <a href="/dashboard/notifications" class="tw-block tw-p-4 tw-text-center cursor:tw-bg-light-2 cursor:tw-text-blue tw-font-bold">Show All</a>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import {createPopper} from "@popperjs/core";

  export default {
    data: v => ({
      is_open: false,
      notifications: [],
      totalUnread: v.initialTotalUnread,
      loading: false,
      last_update: 0,
      last_broadcast: 0,
      initialized: false,
    }),
    props: {
      user: {},
      initialTotalUnread: {},
    },
    created() {
      this.open = _.throttle(() => {
        this.needsRefresh && this.refresh()
        this.is_open = true
      }, 100)
      this.close = _.throttle(() => this.is_open = false, 100)

      Echo.private('App.Models.User.' + this.user.id)
        .notification((notification) => {
          this.last_broadcast = Date.now()
          this.totalUnread++;
          this.open()
        });

      let documentClickCallback = ev => {
        if (ev.target !== this.$el && !this.$el.contains(ev.target)) {
          this.close()
        }
      }
      this.$on('hook:mounted', () => document.addEventListener('click', documentClickCallback))
      this.$on('hook:beforeDestroy', () => document.removeEventListener('click', documentClickCallback))
    },
    computed: {
      latestNotifications() {
        return _.chain(this.notifications)
          .slice(0, 4)
          .value()
      },
      needsRefresh() {
        return this.initialized === false || this.last_update < this.last_broadcast
      },
    },
    methods: {
      delayedRefresh() {
        setTimeout(() => this.refresh(), 500)
      },
      refresh() {
        this.loading = true
        axios.get(`/api/v1/notification/latest`, {
          params: {api_token: this.user.api_token},
        }).then(resp => {
          this.notifications = resp.data.data
          this.totalUnread = resp.data.total
        }).finally(() => {
          this.loading = false
          this.initialized = true
          this.last_update = Date.now()
        })
      }
    },
    watch: {
      is_open(value) {
        value && createPopper(this.$refs.trigger, this.$refs.menu, {
          placement: "bottom",
        })
      }
    }
  }
</script>
